export default function description() {
    return (
        <div className="card__description-basic">
            <div className="card__description">
                <p className="card__description-title">
                    Загальна характеристика
                </p>
                <p className="card__description-text">
                    ГРУТ (НС 6343) — це високопродуктивний гібрид соняшнику нового покоління, який відзначається одним із найвищих потенціалів урожайності серед IMI-гібридів. Він створений для інтенсивних технологій вирощування, але водночас демонструє стабільність у стресових умовах.
                </p>
                <p className="card__description-text">
                    Гібрид поєднує в собі потужний генетичний потенціал, високу посухостійкість і стійкість до ключових хвороб, що робить його універсальним рішенням для різних регіонів України.
                </p>
                <p className="card__description-title">Основні переваги</p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">Один із найвищих потенціалів урожайності — до 5,7 т/га</li>
                    <li className="card__description-numbering">Висока посухостійкість</li>
                    <li className="card__description-numbering">Стійкість до вовчка — 5 рас (A–E)</li>
                    <li className="card__description-numbering">Стійкість до всіх рас несправжньої борошнистої роси</li>
                    <li className="card__description-numbering">Висока адаптивність до різних умов вирощування</li>
                    <li className="card__description-numbering">Потужна енергія росту</li>
                </ol>
                <table className="card__description__table">
                    <tr>
                        <td className="card__description__td">Період вегетації</td>
                        <td className="card__description__th-index">110–115 днів</td>
                    </tr>
                    <tr>
                        <td className="card__description__td">Олійність:</td>
                        <td className="card__description__th-index">49–51%</td>
                    </tr>
                    <tr>
                        <td className="card__description__td card__description__td--link">Висота рослин</td>
                        <td className="card__description__th-index">160–180 см</td>
                    </tr>
                </table>
                <p className="card__description-title">
                    Рекомендації по густоті
                </p>
                <ol className="card__description-list">
                    <li className="card__description-numbering">За достатнього зволоження: 57–63 тис. рослин/га</li>
                    <li className="card__description-numbering">У посушливих умовах: 47–53 тис. рослин/га</li>
                </ol>
                <div className="card__description-title">Стійкість та толерантність</div>
                <ol className="card__description-list">
                    <p className="card__description-text">
                        Стійкість:
                    </p>
                    <li className="card__description-numbering">Посухостійкість, осипання, холодостійкість — 9/10</li>
                    <li className="card__description-numbering">Вилягання — 8/10</li>
                    <p className="card__description-text">
                        Толерантність до хвороб:
                    </p>
                    <li className="card__description-numbering">Біла гниль, вугільна гниль, фомопсис, пероноспороз — 9/10</li>
                    <li className="card__description-numbering">Фомоз, іржа, альтернаріоз, септоріоз, сіра гниль — 8/10</li>
                </ol>
                <div className="card__description-title">Рекомендовані зони вирощування</div>
                <p className="card__description-text">
                    ГРУТ максимально ефективний у Лісостепу та Степу України, де здатен реалізувати свій високий потенціал урожайності. Підходить для інтенсивних господарств та зон з нестабільним зволоженням.
                </p>
                <div className="card__description-title">Рекомендації щодо вирощування</div>
                <p className="card__description-text">
                    Гібрид добре реагує на підвищений агрофон і застосування сучасних технологій захисту рослин. Рекомендується використання гербіцидів системи Clearfield® (наприклад, Євро-Лайтнінг) для контролю бур’янів.
                </p>
                <p className="card__description-text">
                    Завдяки високій стійкості до хвороб і стресів, ГРУТ є надійним вибором навіть у складних умовах.
                </p>
                <p className="card__description-text">
                    ГРУТ — це гібрид для тих, хто хоче максимальний результат і топову врожайність. Ідеальний вибір для господарств, орієнтованих на інтенсивні технології та високий прибуток з гектара.
                </p>
            </div>
            <div className="card__description-preference">
                <div className="aside__title--new">Головні переваги</div>
                <div className="asede__head">
                    <div className="aside__block">Високий потенція урожайності</div>
                    <div className="aside__block">Найкращу віддачу забезпечує на родючих грунтах</div>
                    <div className="aside__block">Один із найбільш високоврожайних гібридів з високим вмістом олії</div>
                </div>
            </div>
        </div>
    );
}
